import React, { useState } from 'react'
import Select from 'react-select'
import { Drawer, Tabs, Dropdown, Menu } from 'antd'
import { useHistory, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { useToggle, timeDiff, useListData, usePet, stringifyDate } from '../../modules'

import Receive from '../reusable/receive'
import Confirm from '../reusable/confirm'
import Modal from "../reusable/modal"
import Patient from '../reusable/patient'

import NewPatient from '../modals/newPatient'

const NewTheatreEntry = ({ onCreate, document }) => {
    const [ranges, setRanges] = useState()
    const [string, setString] = useState('')
    const [id, setId] = useState()

    const history = useHistory()

    const [visible, toggleVisible] = useToggle(true)
    const [details, toggleDetails] = useToggle()
    const [newpatient, toggleNewPatient] = useToggle()

    const [
        { loading: qLoading, error: qError, fetch: fetchBillItems },
        { list },
        { page = 1, limit = 10, navigate, Paginate }
    ] = useListData('billedItemsByCategory', ranges ? { 
        category: 'Theatre Operations',
        string, 
        from: ranges[0]?._d ?? null, 
        to: ranges[1]?._d ?? null,
        order: -1,
    } : { string, category: 'Theatre Operations', order: -1 }, { notify: true }, 'items')

    const close = () => {
        toggleVisible()
        onCreate()
        setTimeout(() => history.goBack(), 300)
    }

    const onComplete = ({}, notif, ops) => {
        notif('Record created successfully', ops('success'))
        setTimeout(close, 300)
    }

    const [{ loading: eLoading }, createBlankEntry] = usePet('createBlankEntry', {
        id: document._id,
        oi: id
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Creating record...' } })

    const refresh = () => {
        navigate(1)
        fetchBillItems()
    }

    const search = str => {
        setString(str)
        refresh()
    }

    const createEntry = _id => {
        setId(_id)
        createBlankEntry()
    }

    const onPerform = data => {
        onCreate(data)
        close()
    }

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            // footer={
            //     <div className="w-full text-right">
            //         <button className="text-white mr-2 hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">Admit Patient</button>                    
            //         <button className="text-white mr-2 hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">Close</button>
            //     </div>
            // }
            width="40%">
            <p className="font-extrabold text-3xl mb-0">New { document?.title }</p>
            <div className="mt-3">
                <div className="sm:flex sm:justify-between sm:items-center mb-4">
                    <input
                        onChange={e => search(e.target.value)}
                        className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                        id="grid-search"
                        type="text"
                        placeholder="Patient Name, OP/IP No." />
                    <button onClick={ toggleNewPatient } className="btn ml-2 py-2.1 hisani-btn-green-light text-white">New Patient</button>
                </div>
                <NewPatient
                    onPerform={ refresh }
                    toggle={ toggleNewPatient }
                    visible={ newpatient }/>
                <Receive
                    progress
                    loading={qLoading}
                    error={qError}>
                    {
                        list?.length > 0 ?
                            <div className="overflow-x-auto">
                                <table className="table-auto w-full">
                                    {/* Table header */}
                                    <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                        <tr>
                                            <th className="p-2">
                                                <div className="font-semibold text-center">No</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-left">Patient Name</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-center"></div>
                                            </th>
                                        </tr>
                                    </thead>
                                    {/* Table body */}
                                    <tbody className="text-sm font-medium divide-y divide-gray-100">
                                        {
                                            list.map((item, key) =>
                                                <tr>
                                                    <td className="p-2">
                                                        <div className="text-center">
                                                            { ((page - 1) * limit) + (key + 1)}.
                                                        </div>
                                                    </td>
                                                    <td className="p-2">
                                                        <Patient patient={ item?.patient } />
                                                    </td>
                                                    <td className="p-2">
                                                        <button disabled={ eLoading } onClick={ () => Confirm({
                                                            title: 'Create entry?',
                                                            message: 'Please confirm before performing this action',
                                                            okText: 'Create entry',
                                                            onOk: () => createEntry(item._id)
                                                        }) } type="submit" className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Create Entry</button>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                            :
                            <div className="w-full h-16 flex items-center justify-center">
                                <p className="font-semibold text-base">You can add a new patient by clicking above</p>
                            </div>
                    }
                </Receive>
                {Paginate}
            </div>
        </Drawer>
    )
}

export default NewTheatreEntry